import { render, staticRenderFns } from "./Zhuyaoyuqinglaiyuan.vue?vue&type=template&id=5142315d&scoped=true&"
import script from "./Zhuyaoyuqinglaiyuan.vue?vue&type=script&lang=js&"
export * from "./Zhuyaoyuqinglaiyuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5142315d",
  null
  
)

export default component.exports